import { Box, Flex } from "@chakra-ui/react";
import { Icons, Typography } from "@reconvert/react-ui-component";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../app/hooks";
import { selectAppState } from "../../app/slice/appSlice";

const WelcomePage = () => {
  const { t } = useTranslation();
  const { isSidebarSticked } = useAppSelector(selectAppState);
  const paddingValue = `${!isSidebarSticked ? "80px" : "256px"}`;

  return (
    <Box
      sx={{
        bg: "neutrals.200",
        w: "100%",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pl: paddingValue,
      }}
    >
      <Box
        sx={{
          maxWidth: "382px",
          width: "100%",
          position: "relative",
          padding: "12px",
        }}
      >
        <Flex
          flexDirection="column"
          alignItems="center"
          gap={2}
        >
          <Typography
            variant="h3-r-medium"
            sx={{
                color: "#1F2937",
                textAlign: "center",
                fontFamily: "Roboto",
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "32px",
            }}
          >
            {t("Welcome to the Flow Builder!")}
          </Typography>
          <Typography
            variant="body"
            sx={{
                color: "#4B5563",
                textAlign: "center",
                fontFamily: "Inter",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "24px",
                marginBottom: "19px",
            }}
          >
            {t("Select a page from the list to begin editing your slots and widgets.")}
          </Typography>
          <Icons.LeftArrow  width="68px" height="23px" />
        </Flex>
      </Box>
    </Box>
  );
};

export default WelcomePage;

